/* eslint-disable max-len */
/* eslint-disable no-unused-expressions */
import { classNames } from 'shared/lib/classNames/classNames';
import { ReactNode, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBackground } from 'features/StepInfo/modal/selectors/getStepInfo/getStepInfo';
import { stepActions } from 'features/StepInfo';
import cls from './BackgroundHandler.module.scss';

interface BackgroundHandlerProps {
    className?: string,
    images?: any,
    gradient?: boolean,
}

const useResize = (): number => {
    const [width, setWidth] = useState<number>(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return width;
};

export const BackgroundHandler = ({ className, images, gradient = true }: BackgroundHandlerProps) => {
    const dispatch = useDispatch();
    const width = useResize();
    // const backgrounds = useSelector(getBackground);

    const getSize = () => {
        if (width <= 1200 && width >= 1024) {
            return 1200;
        }
        if (width <= 1024 && width >= 768) {
            return 1024;
        }
        if (width <= 768 && width >= 480) {
            return 768;
        }
        if (width <= 480) {
            return 370;
        }

        return 1700;
    };

    const setWindowWidth = (width: number) => {
        dispatch(stepActions.setWindowWidth(width));
    };

    const [matches, setMatches] = useState(getSize());

    useEffect(() => {
        setMatches(getSize());
        setWindowWidth(getSize());
    }, [width]);

    const lenearGradient = 'linear-gradient(136deg, rgba(15, 167, 223, 0.50) 0%, rgba(61, 187, 110, 0.50) 57.29%, rgba(142, 245, 11, 0.50) 97.92%)';
    const background = gradient ? `${lenearGradient}, ${images[matches]}` : `${images[matches]}`;

    return (
        <div
            className={classNames(cls.desktop, {
                [cls.mobile]: matches === 370,
            })}
            style={{ backgroundImage: background }}
        />
    );
};
